import React from 'react';
import ReactDOM from 'react-dom';
import './css//index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';

window.cached = {};
const cachedVocabs = localStorage.getItem('cached.vocabs');
const cachedVocabsDate = localStorage.getItem('cached.vocabs.date');
if (cachedVocabs && cachedVocabsDate) {
    if (new Date() - new Date(cachedVocabsDate) < 2*24*60*60*1000) { // 2 days of caching
        try {
            window.cached.vocabs = JSON.parse(cachedVocabs);
        } catch (e) {
            console.log(e);
        }
    }
}
ReactDOM.render(<App />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
